module.exports = __webpack_public_path__ + "img/2.0dd5f1a1.png";